import axios from '@modules/raccoon/src/api';
import { Import } from '../pages';

const endpoint = 'dane/opcje';

export const getImportsElement = () =>
  axios.get(endpoint).then(({ data }) => {
    const items = data.map((item) => ({
      text: item.Description,
      path: `/importy/${item.Entity}`,
      component: Import,
      customProps: {
        OptionName: item.Entity,
        Title: item.Description
      }
    }));
    return [{ text: 'importy', items }];
  });
